
export default function HowToApply() {
  const steps = [
    {
      number: '1',
      title: '公式サイトにアクセス',
      description: '下記のボタンから公式サイトへアクセスし、「カードをつくる」ボタンをクリックします。',
      icon: 'ri-cursor-line',
    },
    {
      number: '2',
      title: '会員登録・ログイン',
      description: '会員でない方は新規登録、すでに会員の方はログインします。会員情報が自動入力されるので便利です。',
      icon: 'ri-user-add-line',
    },
    {
      number: '3',
      title: '必要情報を入力',
      description: '氏名、住所、電話番号、勤務先情報などの必要事項を入力します。所要時間は約10分程度です。',
      icon: 'ri-edit-line',
    },
    {
      number: '4',
      title: '本人確認書類を提出',
      description: '運転免許証やマイナンバーカードなどの本人確認書類をスマホで撮影してアップロードします。',
      icon: 'ri-id-card-line',
    },
    {
      number: '5',
      title: '審査結果を待つ',
      description: '審査は最短数分で完了。結果はメールで届きます。審査通過後、約1週間でカードが届きます。',
      icon: 'ri-time-line',
    },
    {
      number: '6',
      title: 'カードを受取・利用開始',
      description: '届いたカードを受け取り、会員サイトで初期設定を行えば利用開始。入会特典ポイントも獲得できます。',
      icon: 'ri-mail-line',
    },
  ];

  const required = [
    '本人確認書類（運転免許証、マイナンバーカード、パスポートなど）',
    '銀行口座情報（引き落とし口座）',
    'メールアドレス（会員登録用）',
    '電話番号',
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#FFF5F5] to-[#FFF0F0]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-3 text-center">
          大手ECモール系カードの申込み方法
        </h2>
        <p className="text-gray-600 text-center mb-12">簡単6ステップで申込み完了！</p>

        <div className="mb-12">
          <div className="relative">
            {steps.map((step, index) => (
              <div key={index} className="relative mb-8 last:mb-0">
                <div className="flex items-start gap-4">
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 flex items-center justify-center bg-[#BF0000] rounded-full shadow-lg">
                      <i className={`${step.icon} text-white text-2xl`}></i>
                    </div>
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 -z-10 w-12 h-12 bg-[#BF0000]/20 rounded-full"></div>
                    {index < steps.length - 1 && (
                      <div className="absolute top-16 left-1/2 -translate-x-1/2 w-0.5 h-16 bg-[#BF0000]/30"></div>
                    )}
                  </div>
                  <div className="flex-1 bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="bg-[#333333] text-white text-xs font-bold px-3 py-1 rounded-full">
                        STEP {step.number}
                      </span>
                      <h3 className="text-lg font-bold text-[#333333]">{step.title}</h3>
                    </div>
                    <p className="text-gray-700 text-sm leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8">
          <h3 className="text-xl font-bold text-[#333333] mb-4 flex items-center gap-2">
            <i className="ri-file-list-line text-[#BF0000] text-2xl"></i>
            申込みに必要なもの
          </h3>
          <ul className="space-y-3">
            {required.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700 text-sm">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-[#FFF8E1] border-l-4 border-[#BF0000] rounded-lg p-6">
          <h4 className="text-[#333333] font-bold text-base mb-2 flex items-center gap-2">
            <i className="ri-information-line text-[#BF0000] text-xl"></i>
            入会キャンペーン実施中
          </h4>
          <p className="text-gray-700 text-sm leading-relaxed mb-3">
            今なら新規入会＋利用で<strong className="text-[#BF0000]">最大8,000ポイント</strong>プレゼント！
            さらにJCBブランド選択で+3,000ポイントの特典も。
          </p>
          <p className="text-gray-600 text-xs">
            ※キャンペーン期間や条件は公式サイトでご確認ください
          </p>
        </div>
      </div>
    </section>
  );
}
